export default function FontIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" {...props}>
			<path d="M420.391-146.999v-546.783h-230v-119.219h579.218v119.219h-230v546.783H420.391Z" />
		</svg>
	)
}
